document.addEventListener('DOMContentLoaded', () => {
  const hoverDelay = 150;
  let hoverLock = null;

  document.querySelectorAll('.hc-color-src').forEach((swatch) => {
    const productId = swatch.dataset.product;
    const imageUrl = swatch.dataset.src;
    const title = swatch.dataset.title;
    const price = swatch.dataset.price;

    const media = document.querySelector(`.media--transparent[data-product="${productId}"]`);
    const infoBox = document.querySelector(`.hc-color-info[data-product="${productId}"]`);
    const mainPrice = document.querySelector(`.hc-main-price[data-product="${productId}"]`);
    //const titleEl = infoBox?.querySelector('.hc-color-title');
    const priceEl = infoBox?.querySelector('.hc-color-price');

    function updateVisuals() {
      if (media) {
        const images = media.querySelectorAll('img');
        if (images.length > 0) {
          const targetImg = images[images.length - 1];
          targetImg.src = imageUrl;
          targetImg.removeAttribute('srcset');
        }
      }

      if (priceEl) priceEl.textContent = price ? `£${(Number(price) / 100).toFixed(2)}` : '';

      if (mainPrice) mainPrice.classList.add('inactive');
      if (infoBox) infoBox.classList.add('active');
    }

    function hideVisuals() {
      if (mainPrice) mainPrice.classList.remove('inactive');
      if (infoBox) infoBox.classList.remove('active');
    }

    swatch.addEventListener('mouseenter', (e) => {
      e.preventDefault();
      clearTimeout(hoverLock);
      updateVisuals();
    });

    swatch.addEventListener('mouseleave', () => {
      hoverLock = setTimeout(hideVisuals, hoverDelay);
    });

    if (infoBox) {
      infoBox.addEventListener('mouseenter', () => clearTimeout(hoverLock));
      infoBox.addEventListener('mouseleave', () => {
        hoverLock = setTimeout(hideVisuals, hoverDelay);
      });
    }
  });
});
